<template>
	<div>
		<vx-card title="Handleiding">
			<div class="w-full vx-row">
				<div class="vx-col w-full">
					<label>Heb je vragen over de werking van Piqwise? We proberen alle functies uit te leggen op onze wiki. Daar staan de meest
						voorkomende situaties beschreven met veel plaatjes zodat je direct weet wat je moet doen.</label><br /><br />
				</div>
				<div class="vx-col w-full">
					<vs-button color="primary" @click.native="openWiki()" type="border">Naar de wiki</vs-button>
				</div>
			</div>
		</vx-card>
		<br />
		<vx-card title="Contact">
			<div class="w-full vx-row">
				<div class="vx-col w-full">
					<label>Kom je er na het lezen van de handleiding nog steeds niet uit? Of heb je andere vragen met betrekking tot Piqwise?
						Stel ze ons gerust! Wij zijn bereikbaar via: </label><br /><br />
				</div>
			</div>
			<div class="w-full vx-row">
				<div class="vx-col  sm:w-1/1 md:w-1/3 lg:w-1/3 xl:w-1/3">
					<vx-card title="Live chat" class="cards">
						<i class="fas fa-comments icons"></i><br /><br />
						<p>Onze livechat is te bereiken via het knopje in de rechter beneden hoek</p>
						<p class="lbl-conditions">We beantwoorden je chat bericht binnen twee kantoor uren.</p>
					</vx-card>
				</div>
				<div class="vx-col  sm:w-1/1 md:w-1/3 lg:w-1/3 xl:w-1/3">
					<vx-card title="Email" class="cards">
						<i class="far fa-envelope icons"></i><br /><br />
						<p>Stuur gerust een email naar <a href="mailto:info@piqwise.com">info@piqwise.com</a></p><br />
						<p class="lbl-conditions"> We beantwoorden je email binnen twee werkdagen.</p>
					</vx-card>
				</div>
				<div class="vx-col sm:w-1/1 md:w-1/3 lg:w-1/3 xl:w-1/3">
					<vx-card title="Telefoon" class="cards">
						<i class="fas fa-phone icons"></i><br /><br />
						<p>038 200 1098 <br />We zijn bereikbaar op werkdagen van 8:30 - 17:00</p>
						<p class="lbl-conditions"> Sprak je onze voicemail in? We bellen je de eerstvolgende werkdag</p>
					</vx-card>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
export default {
	methods: {
		openWiki() {
			window.open(this.$store.state.wiki.wiki.overview);
		},
	}
}
</script>

<style scoped>
.lbl-conditions {
	font-size: 9px;
}

.icons {
	font-size: 40px;

}

.cards {
	text-align: center;
}
</style>